import { useTranslation } from 'react-i18next'
import { AcceptInviteForm } from '@/components/features/auth'

export function AcceptInvitePage() {
  const { t } = useTranslation('auth')

  return (
    <div className="w-full max-w-md">
      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold">{t('acceptInvitation')}</h1>
        <p className="text-muted-foreground">{t('setYourPassword')}</p>
      </div>
      <AcceptInviteForm />
    </div>
  )
}
